import React from 'react';
import { OverviewLayout } from '../../components/DetailLayout';
import Link from '../../components/Link';
import OverviewLayoutSection from '../../components/OverviewLayout/OverviewLayoutSection';
import Typography from '../../components/Typography';
import useConfig from '../../hooks/config.hooks';
import { translate } from '../../i18n';
import ECounterAppointments from './ECounterAppointments';
import ECounterTickets from './ECounterTickets';

const ECounter: React.FC = () => {
  const { APPOINTMENTS_URL, ENTREPRENEURS_URL, REQUEST_URL, NOTIFICATION_URL, ECOUNTER_INFO_URL } =
    useConfig();

  return (
    <OverviewLayout title="ecounter.title">
      <OverviewLayoutSection title={translate('ecounter.appointments.title')}>
        <Link to={APPOINTMENTS_URL} classNames="a-button" target="_blank">
          {translate('ecounter.appointments.new')}
        </Link>

        <ECounterAppointments />
      </OverviewLayoutSection>
      <OverviewLayoutSection title={translate('ecounter.requests.title')}>
        <Link to={REQUEST_URL} classNames="a-button" target="_blank">
          {translate('ecounter.requests.new')}
        </Link>

        <ECounterTickets
          endpoint="/activities/requests"
          loadMoreLabel="ecounter.requests.load_more"
          emptyMessage="ecounter.requests.empty"
        />

        <Typography variant="h3" as="h5" classNames="u-margin-top u-margin-bottom-xs">
          {translate('ecounter.requests.entrepreneur.title')}
        </Typography>

        <Link to={ENTREPRENEURS_URL} target="_blank">
          {translate('ecounter.requests.entrepreneur.link')}
        </Link>
      </OverviewLayoutSection>
      <OverviewLayoutSection
        title={translate('ecounter.notifications.title')}
        description={translate('ecounter.notifications.description')}
      >
        <Link to={NOTIFICATION_URL} classNames="a-button u-margin-bottom" target="_blank">
          {translate('ecounter.notifications.new')}
        </Link>

        <ECounterTickets
          endpoint="/activities/notifications"
          loadMoreLabel="ecounter.notifications.load_more"
          emptyMessage="ecounter.notifications.empty"
        />

        {/* <Typography variant="h2" as="h6" classNames="u-margin-top u-margin-bottom-xs">
          {translate('ecounter.more_info.title')}
        </Typography>

        <Link to={ECOUNTER_INFO_URL}>{translate('ecounter.more_info.link')}</Link> */}
      </OverviewLayoutSection>
    </OverviewLayout>
  );
};

export default ECounter;
